// 产品研发（/product-research）· 参考图版「酪蛋白研发中心实时数据看板」
// 布局按用户参考图（2026-10-20）：
//   左列：研发项目总览(892) + 设备运行情况(980)，内容尺寸不变
//   中列通高：实验室三维可视化场景（媒体区 3129×1760 = 16:9）
//   右列上排：成都VS炉霍 产品试验(1727) + 论文区(1013)
//   右列下排：两地同步实验实时视频区(单，1727，媒体区 1667×938 = 16:9) + 研发专利(1013)
// 舞台 7680×2160 等比缩放一屏展示；数据走 CMS（$C/$CList）可后台维护，未配置用内置默认
<template>
  <div class="pr-page" :style="rootVars">
    <div class="pr-viewport" ref="viewport">
      <div class="pr-scale-box" ref="box">
        <div class="pr-stage" ref="stage">
          <!-- 页头：返回 | 标题横幅（居中） | 实时时间 -->
          <header class="pr-head">
            <button class="pr-back" type="button" @click="goBack">
              <span class="pr-back-arrow">←</span> {{ fromChain ? $C('productResearch','backFromChain','返回产业链') : $C('productResearch','backDefault','返回') }}
            </button>
            <div class="pr-banner">
              <h1 class="pr-title">{{ $C('productResearch','headTitle','酪蛋白研发中心实时数据看板') }}</h1>
            </div>
            <div class="pr-clock">{{ nowText }}</div>
          </header>

          <section class="pr-grid">
            <!-- 左列：研发项目总览 + 设备运行情况（内容与尺寸保持不变） -->
            <div class="pr-col pr-col-l">
              <article class="pr-panel pj-panel">
                <div class="pr-panel-head"><span class="pr-panel-title">{{ $C('productResearch','pjTitle','研发项目总览') }}</span></div>
                <div class="pr-panel-body">
                  <p class="pr-total-line">{{ $C('productResearch','pjTotalPre','项目总数') }}：<b>{{ projectsTotal }}</b>{{ $C('productResearch','pjTotalSuf','项') }}</p>
                  <ul class="pr-row-list">
                    <li v-for="(p, i) in projects" :key="i" @click="openMolecule(i)" title="点击查看三维分子结构">
                      <span class="pr-item-name">{{ p.name }}<i class="pr-item-3d">3D</i></span>
                      <em class="pr-item-status" :class="'pj-' + p.statusKey">{{ p.status }}</em>
                    </li>
                  </ul>
                </div>
              </article>

              <article class="pr-panel dv-panel">
                <div class="pr-panel-head"><span class="pr-panel-title">{{ $C('productResearch','dvTitle','设备运行情况') }}</span></div>
                <div class="pr-panel-body">
                  <p class="pr-total-line">{{ $C('productResearch','dvTotalPre','设备总数') }}：<b>{{ deviceTotal }}</b>{{ $C('productResearch','dvTotalSuf','台') }}</p>
                  <ul class="pr-row-list">
                    <li v-for="(d, i) in panelDevices" :key="i">
                      <span class="pr-item-name">{{ d.name }}</span>
                      <em class="pr-item-status" :class="'dv-' + d.status">{{ d.status === 'running' ? '运行中' : '待机中' }}</em>
                    </li>
                  </ul>
                </div>
              </article>
            </div>

            <!-- 中列（通高）：实验室三维可视化场景，媒体区 3129×1760 = 16:9 -->
            <article class="pr-panel vs-panel">
              <div class="pr-panel-head"><span class="pr-panel-title">{{ $C('productResearch','vsTitle','可视化场景') }}</span></div>
              <div class="pr-panel-body">
                <img v-if="vsMedia" class="pr-media" :src="vsMedia" alt="实验室三维可视化场景" />
                <div v-else class="pr-ph">
                  <div class="pr-ph-grid" aria-hidden="true"></div>
                  <p class="pr-ph-text">{{ $C('productResearch','vsPlaceholder','实验室三维可视化场景待接入') }}</p>
                </div>
              </div>
            </article>

            <!-- 右列：上排 产品试验 + 论文区；下排 视频区 + 研发专利 -->
            <div class="pr-col pr-col-r">
              <div class="pr-row pr-row-top">
                <article class="pr-panel trial-panel">
                  <div class="pr-panel-head">
                    <span class="pr-panel-title">{{ $C('productResearch','trialTitle','成都VS炉霍 产品试验') }}</span>
                    <div class="pr-legend">
                      <span><i class="dot cd"></i>{{ trial.cdLabel }}</span>
                      <span><i class="dot lh"></i>{{ trial.lhLabel }}</span>
                    </div>
                  </div>
                  <div class="pr-panel-body">
                    <div class="pr-chart-title">{{ $C('productResearch','trialChartTitle','关键产品试验指标纯度提取对比（%）') }}</div>
                    <div class="pr-chart-body">
                      <div class="pr-yaxis">
                        <span v-for="v in yTicks" :key="v">{{ v }}%</span>
                      </div>
                      <div class="pr-bars">
                        <div class="pr-group" v-for="(c, gi) in trial.categories" :key="c">
                          <div class="pr-bars-row">
                            <div class="pr-bar-wrap" v-for="b in trialBars(gi)" :key="b.k">
                              <em class="pr-bar-val">{{ b.v }}%</em>
                              <i class="pr-bar" :class="b.k" :style="{ height: 'calc((100% - 52px) * ' + (b.v / 100) + ')' }"></i>
                            </div>
                          </div>
                          <div class="pr-x-label">{{ c }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>

                <article class="pr-panel pp-panel">
                  <div class="pr-panel-head"><span class="pr-panel-title">{{ $C('productResearch','ppTitle','论文区') }}</span></div>
                  <div class="pr-panel-body">
                    <ul class="pr-row-list pr-pp-list">
                      <li v-for="(t, i) in papers" :key="i" @click="openPaper(i)" title="点击阅读论文全文（PDF）">
                        <span class="pr-pp-idx">{{ i + 1 }}</span>
                        <span class="pr-pp-name">{{ t.title }}</span>
                        <span class="pr-pp-go">PDF</span>
                      </li>
                    </ul>
                  </div>
                </article>
              </div>

              <div class="pr-row pr-row-btm">
                <!-- 视频区：单一监控面板，媒体显示区 16:9（1667×938） -->
                <article class="pr-panel mn-panel">
                  <div class="pr-panel-head"><span class="pr-panel-title">{{ $C('productResearch','mn1Title','两地同步实验实时视频区') }}</span></div>
                  <div class="pr-panel-body">
                    <video v-if="mnMedia && !mnIsImage" class="pr-video" :src="mnMedia" autoplay muted playsinline controls></video>
                    <img v-else-if="mnMedia" class="pr-media" :src="mnMedia" alt="两地同步实验室实景" />
                    <div v-else class="pr-ph">
                      <div class="pr-ph-grid" aria-hidden="true"></div>
                      <p class="pr-ph-text">{{ $C('productResearch','mnPlaceholder','两地同步实验实时视频待接入') }}</p>
                    </div>
                  </div>
                </article>

                <article class="pr-panel pt-panel">
                  <div class="pr-panel-head"><span class="pr-panel-title">{{ $C('productResearch','ptTitle','研发专利') }}</span></div>
                  <div class="pr-panel-body">
                    <div class="pr-pt-grid">
                      <div class="pr-pt" v-for="(p, i) in patPageItems" :key="p.no" :title="p.name" @click="openPatent(patPageBase + i)">
                        <div class="pr-pt-pic"><img class="pr-pt-img" :src="assetUrl(p.img)" :alt="p.name" loading="lazy" /></div>
                        <span class="pr-pt-name">{{ p.name }}</span>
                        <span class="pr-pt-no">{{ p.no }}</span>
                      </div>
                    </div>
                    <div class="pr-pt-pager" v-if="patPageCount > 1">
                      <button class="pr-pt-pg-btn" type="button" :disabled="patPage === 0" @click="patPage--">‹</button>
                      <span class="pr-pt-pg-num">{{ patPage + 1 }} / {{ patPageCount }}</span>
                      <button class="pr-pt-pg-btn" type="button" :disabled="patPage >= patPageCount - 1" @click="patPage++">›</button>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

    <!-- 专利证书全屏放大（v-portal 挂 body；内容包 7680×2160 舞台，随 --screen-scale 缩放，与主界面同分辨率同比例） -->
    <div class="pr-lightbox" v-portal :style="rootVars" v-if="lightbox !== null" @click.self="closeOverlays">
      <div class="pr-ov-stage">
        <div class="pr-light-head">
        <div class="pr-light-info">
          <p class="pr-light-name">{{ activePatent.name }}</p>
          <p class="pr-light-no" v-if="activePatent.no">专利号：{{ activePatent.no }}</p>
          <p class="pr-light-hint">滚轮缩放 · 按住拖动平移 · 双击复位 · 点击空白处 / 右上角「返回」/ ESC 回到产品研发 · ‹ › 切换证书</p>
        </div>
        <button class="pr-close-btn" type="button" title="返回产品研发 (ESC)" @click="closeOverlays"><span class="pr-close-x">×</span><span class="pr-close-t">返回</span></button>
      </div>
      <div class="pr-light-body" @click.self="closeOverlays">
        <img
          class="pr-light-img"
          :class="{ grabbing: patDragging }"
          :src="assetUrl(activePatent.img)"
          :alt="activePatent.name"
          :style="{ transform: 'translate(' + patX + 'px, ' + patY + 'px) scale(' + patZoom + ')' }"
          @wheel.prevent="patWheel"
          @mousedown.prevent="patDown"
          @dblclick.prevent="patReset"
          title="滚轮缩放 · 按住拖动平移 · 双击复位"
        />
        <button class="pr-light-nav prev" type="button" v-if="patents.length > 1" @click.stop="stepPatent(-1)">‹</button>
        <button class="pr-light-nav next" type="button" v-if="patents.length > 1" @click.stop="stepPatent(1)">›</button>
        </div>
      </div>
    </div>

    <!-- 论文 PDF 阅读弹层（v-portal 挂 body；内容随 --screen-scale 缩放，与主界面同比例） -->
    <div class="pr-pdfview" v-portal :style="rootVars" v-if="paperIdx !== null" @click.self="closeOverlays">
      <div class="pr-ov-stage">
        <div class="pr-pdf-panel">
        <div class="pr-pdf-head">
          <p class="pr-pdf-title">{{ paperTitle }}</p>
          <div class="pr-pdf-actions">
            <a class="pr-pdf-new" :href="paperFile" target="_blank">新窗口打开</a>
            <button class="pr-close-btn" type="button" title="返回产品研发 (ESC)" @click="closeOverlays"><span class="pr-close-x">×</span><span class="pr-close-t">返回</span></button>
          </div>
        </div>
        <iframe class="pr-pdf-frame" v-if="paperFile" :src="paperFile"></iframe>
        </div>
      </div>
    </div>

    <!-- 三维分子结构下级页（v-portal 挂 body；内容随 --screen-scale 缩放，3Dmol 可拖动 / 滚轮缩放 / 右键平移） -->
    <div class="pr-molecule" v-portal :style="rootVars" v-if="moleculeOpen && activeMolecule.file">
      <div class="pr-ov-stage pr-ov-molbg">
        <div class="pr-mol-head">
        <button class="pr-mol-back" type="button" @click="closeMolecule">‹ 返回产品研发</button>
        <p class="pr-mol-title">三维分子结构交互展示<span class="pr-mol-title-en">INTERACTIVE MOLECULAR STRUCTURE</span></p>
        <button class="pr-close-btn" type="button" title="返回产品研发 (ESC)" @click="closeMolecule"><span class="pr-close-x">×</span><span class="pr-close-t">返回</span></button>
      </div>
      <div class="pr-mol-body">
        <div class="pr-mol-main">
          <aside class="pr-mol-nav">
            <p class="pr-mol-nav-t">研发项目 · 分子名称</p>
            <button class="pr-mol-nav-item" :class="{ on: i === moleculeIdx }" v-for="(m, i) in molecules" :key="i" type="button" @click="moleculeIdx = i">
              <span>{{ m.molecule }}</span><i>›</i>
            </button>
          </aside>
          <figure class="pr-mol-view">
            <div class="pr-mol-stage">
              <div class="pr-mol-canvas" ref="molCanvas"></div>
              <div class="pr-mol-orbs" aria-hidden="true">
                <span class="pr-orb" v-for="(o, i) in orbs" :key="i" :style="orbStyle(o)"></span>
              </div>
              <div class="pr-mol-loading" v-if="!viewerReady">
                <img v-if="activeMolecule.img" class="pr-mol-poster" :src="assetUrl(activeMolecule.img)" alt="" />
                <span class="pr-mol-loading-t">3D 结构加载中…</span>
              </div>
              <div class="pr-mol-tools">
                <button type="button" @click="resetView">重置视角</button>
                <button type="button" :class="{ on: spinOn }" @click="toggleSpin">{{ spinOn ? '停止自转' : '自动旋转' }}</button>
              </div>
              <transition name="pr-fade">
                <div class="pr-mol-tip" v-if="hoverInfo" :style="{ left: tipPos.x + 'px', top: tipPos.y + 'px' }">
                  <p class="pr-mol-tip-name">{{ hoverInfo[0] ? hoverInfo[0].v : activeMolecule.molecule }}</p>
                  <p class="pr-mol-tip-row" v-for="(p, i) in hoverInfo.slice(1)" :key="i">
                    <em>{{ p.k }}</em><span>{{ p.v }}</span>
                  </p>
                </div>
              </transition>
              <p class="pr-mol-hint">鼠标左键拖动旋转 · 滚轮缩放 · 右键拖动平移 · 悬停查看原子信息</p>
            </div>
            <figcaption class="pr-mol-cap">
              {{ activeMolecule.molecule }} · 三维结构
              <em v-if="activeMolecule.source">数据来源：{{ activeMolecule.source }}</em>
            </figcaption>
          </figure>
          <aside class="pr-mol-info">
            <p class="pr-mol-name">{{ activeMolecule.molecule }}</p>
            <p class="pr-mol-project">{{ activeMolecule.project }}</p>
            <div class="pr-mol-meta" v-if="activeMolecule.gene">
              <span class="pr-mol-meta-k">基因</span><span class="pr-mol-meta-v">{{ activeMolecule.gene }}</span>
              <span class="pr-mol-meta-k">Accession</span><span class="pr-mol-meta-v">{{ activeMolecule.acc }}</span>
            </div>
            <div class="pr-mol-stats" v-if="!activeMolecule.isLigand && activeResidues">
              <div class="pr-mol-stat"><b>{{ activeResidues }}</b><i>残基 (aa)</i></div>
              <div class="pr-mol-stat"><b>{{ pLDDTMeanText }}</b><i>置信度均值</i></div>
            </div>
            <div class="pr-mol-intro">{{ activeMolecule.intro }}</div>
          </aside>
        </div>

        <div class="pr-mol-analysis">
          <!-- 01 置信度曲线 -->
          <article class="pr-an-panel an-conf">
            <div class="pr-an-head"><span class="pr-an-no">01</span><span class="pr-an-title">置信度曲线</span></div>
            <div class="pr-an-body">
              <svg class="pr-an-svg" viewBox="0 0 1000 340" preserveAspectRatio="none" v-if="activePLDDT.length">
                <rect x="0" y="0" width="1000" height="68" fill="rgba(49,229,139,0.10)"></rect>
                <rect x="0" y="68" width="1000" height="102" fill="rgba(255,201,66,0.08)"></rect>
                <rect x="0" y="170" width="1000" height="170" fill="rgba(255,107,107,0.07)"></rect>
                <line x1="0" y1="170" x2="1000" y2="170" stroke="rgba(255,107,107,0.5)" stroke-width="1.5" stroke-dasharray="8 8"></line>
                <line x1="0" y1="68" x2="1000" y2="68" stroke="rgba(49,229,139,0.5)" stroke-width="1.5" stroke-dasharray="8 8"></line>
                <path :d="pLDDTPath" fill="none" stroke="#31FFFF" stroke-width="3" stroke-linejoin="round"></path>
                <line x1="0" :y1="pLDDTMeanY" x2="1000" :y2="pLDDTMeanY" stroke="#FFD942" stroke-width="2" stroke-dasharray="6 6"></line>
              </svg>
              <div class="pr-an-empty" v-else>该结构为小分子配体，无逐残基置信度曲线</div>
              <div class="pr-an-foot">
                <span class="pr-an-foot-l">均值 {{ pLDDTMeanText }}</span>
                <span class="pr-an-foot-r">置信度区域得分 × {{ activeResidues || 0 }} aa</span>
              </div>
            </div>
          </article>

          <!-- 02 氨基酸组成 -->
          <article class="pr-an-panel an-aa">
            <div class="pr-an-head"><span class="pr-an-no">02</span><span class="pr-an-title">氨基酸组成</span></div>
            <div class="pr-an-body" v-if="aaTop.length">
              <div class="pr-aa-row" v-for="(a, i) in aaTop" :key="i">
                <span class="pr-aa-code">{{ a.code }}</span>
                <span class="pr-aa-name">{{ a.name }}</span>
                <span class="pr-aa-track"><i class="pr-aa-bar" :style="{ width: aaBarWidth(a) }"></i></span>
                <span class="pr-aa-pct">{{ a.pct }}%</span>
              </div>
              <p class="pr-an-foot pr-an-foot-r2">按相对占比排序 · TOP 8</p>
            </div>
            <div class="pr-an-empty" v-else>该结构为小分子配体，无氨基酸组成</div>
          </article>

          <!-- 03 磷酸化板 -->
          <article class="pr-an-panel an-phos">
            <div class="pr-an-head"><span class="pr-an-no">03</span><span class="pr-an-title">磷酸化板</span></div>
            <div class="pr-an-body pr-phos-body" v-if="phosphoDots.length">
              <div class="pr-phos-grid" :style="{ '--cols': phosCols }">
                <span v-for="d in phosphoDots" :key="d.i" class="pr-phos-dot" :class="['b-' + d.band, { phos: d.phos }]" :title="'残基 ' + (d.i + 1) + ' · pLDDT ' + d.v"></span>
              </div>
              <ul class="pr-phos-legend">
                <li><i class="lg phos"></i>已标记 Ser <b>{{ phosphoSer }}</b></li>
                <li><i class="lg hi"></i>pLDDT &gt; 80 共 <b>{{ phosphoHigh }}</b></li>
                <li><i class="lg lo"></i>pLDDT &lt; 70 共 <b>{{ phosphoLow }}</b></li>
                <li><i class="lg est"></i>预估 <b>{{ phosphoEstimated }}</b> 补偿</li>
              </ul>
            </div>
            <div class="pr-an-empty" v-else>该结构为小分子配体，无磷酸化位点</div>
          </article>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  PANEL_PROJECTS, PANEL_PROJECT_TOTAL, PANEL_TRIAL, PANEL_PATENTS,
  PANEL_PAPERS,   PANEL_DEVICES, PANEL_DEVICE_TOTAL, LIVE_PORTS, MOLECULES,
} from '@/data/productResearch'
import { mediaUrl } from '@/cms/config'
import shichangBg from '@/assets/bg_shichang.jpg'

export default {
  name: 'productResearch',
  data() {
    return {
      scale: 1,
      nowText: '',
      clockTimer: null,
      // 浮层状态（均不占主舞台布局）
      patPage: 0,          // 专利分页当前页
      lightbox: null,      // 当前全屏放大的专利下标，null=关闭
      patZoom: 1,          // 灯箱图片缩放
      patX: 0,             // 灯箱图片平移 X（舞台布局像素）
      patY: 0,             // 灯箱图片平移 Y
      patDragging: false,  // 灯箱图片拖动中
      paperIdx: null,      // 当前打开的论文下标，null=关闭
      moleculeOpen: false, // 分子结构下级页
      moleculeIdx: 0,
      viewerReady: false,
      spinOn: false,
      hoverInfo: null,     // 悬停原子信息（null=未悬停）
      tipPos: { x: 0, y: 0 },
      // 悬浮球状体装饰（分子场景背景）：多维多色低饱和光球
      orbs: [
        { x: 10, y: 16, s: 190, c: '#FFD942' },
        { x: 80, y: 10, s: 120, c: '#31FFFF' },
        { x: 88, y: 68, s: 230, c: '#9B8CFF' },
        { x: 20, y: 80, s: 160, c: '#FF7AB6' },
        { x: 56, y: 38, s: 140, c: '#31E58B' },
        { x: 40, y: 28, s: 92, c: '#FF9845' },
        { x: 68, y: 86, s: 110, c: '#4F9DFF' },
        { x: 6, y: 50, s: 130, c: '#7CF6FF' },
        { x: 92, y: 42, s: 96, c: '#FFC857' },
        { x: 32, y: 60, s: 80, c: '#B388FF' },
      ],
    }
  },
  computed: {
    /* ---- 数据层接入 CMS：后台「产品研发数字化 → 结构化数据」可直接维护，未配置时用内置默认 ---- */
    projects() { return this.$CList('productResearch', 'panelProjects', PANEL_PROJECTS) },
    projectsTotal() { return this.$C('productResearch', 'panelProjectTotal', PANEL_PROJECT_TOTAL) },
    trial() { return this.$C('productResearch', 'panelTrial', PANEL_TRIAL) },
    patents() { return this.$CList('productResearch', 'panelPatents', PANEL_PATENTS) },
    papers() { return this.$CList('productResearch', 'panelPapers', PANEL_PAPERS) },
    // 分子数据（内置，与研发项目一一对应）
    molecules() { return MOLECULES },
    activeMolecule() { return this.molecules[this.moleculeIdx] || {} },
    // ===== 分子结构分析展示（置信度曲线 / 氨基酸组成 / 磷酸化板 / 悬浮球状体） =====
    activeResidues() { return this.activeMolecule.residues || 0 },
    activePLDDT() { return this.activeMolecule.pLDDT || [] },
    pLDDTMean() {
      const a = this.activePLDDT
      if (!a.length) return 0
      return a.reduce((x, y) => x + y, 0) / a.length
    },
    pLDDTMeanText() { return this.activePLDDT.length ? (this.pLDDTMean / 100).toFixed(2) : '—' },
    pLDDTPath() {
      const a = this.activePLDDT
      if (!a.length) return ''
      const W = 1000, H = 340, padT = 12, padB = 12
      const n = a.length
      const x = i => (W * i) / (n - 1)
      const y = v => padT + (H - padT - padB) * (1 - v / 100)
      return a.map((v, i) => (i ? 'L' : 'M') + x(i).toFixed(1) + ' ' + y(v).toFixed(1)).join(' ')
    },
    pLDDTMeanY() {
      const H = 340, padT = 12, padB = 12
      return padT + (H - padT - padB) * (1 - this.pLDDTMean / 100)
    },
    aaTop() { return this.activeMolecule.aaTop || [] },
    aaMax() {
      const a = this.aaTop
      if (!a.length) return 1
      return Math.max.apply(null, a.map(x => x.pct))
    },
    phosphoSites() { return (this.activeMolecule.phospho && this.activeMolecule.phospho.sites) || [] },
    phosphoEstimated() { return (this.activeMolecule.phospho && this.activeMolecule.phospho.estimated) || 0 },
    phosphoHigh() { return this.activePLDDT.filter(v => v > 80).length },
    phosphoLow() { return this.activePLDDT.filter(v => v < 70).length },
    phosCols() {
      const n = this.activePLDDT.length
      if (!n) return 1
      return Math.max(12, Math.min(44, Math.round(Math.sqrt(n * 2))))
    },
    phosphoDots() {
      const a = this.activePLDDT
      const sites = new Set(this.phosphoSites)
      return a.map((v, i) => ({
        i, v,
        band: v >= 80 ? 'hi' : v >= 70 ? 'mid' : 'lo',
        phos: sites.has(i + 1),
      }))
    },
    phosphoSer() { return this.phosphoSites.length },
    activePatent() { return this.lightbox !== null ? (this.patents[this.lightbox] || {}) : {} },
    paperTitle() {
      if (this.paperIdx === null) return ''
      const p = this.papers[this.paperIdx] || {}
      return p.title || ''
    },
    paperFile() {
      if (this.paperIdx === null) return ''
      const p = this.papers[this.paperIdx] || {}
      return p.file ? this.assetUrl(p.file) : ''
    },
    // 专利分页：每页 6 项（3 列 × 2 行）
    patPageCount() { return Math.max(1, Math.ceil(this.patents.length / 6)) },
    patPageBase() { return this.patPage * 6 },
    patPageItems() { return this.patents.slice(this.patPageBase, this.patPageBase + 6) },
    panelDevices() { return this.$CList('productResearch', 'panelDevices', PANEL_DEVICES) },
    deviceTotal() { return this.$C('productResearch', 'panelDeviceTotal', PANEL_DEVICE_TOTAL) },
    // 监控流（后台可配置 url；全部未配置时显示待接入占位）
    streams() {
      return this.$C('productResearch', 'livePorts', LIVE_PORTS).map(p => Object.assign({}, p))
    },
    hasStream() {
      return this.streams.some(s => !!s.url)
    },
    // 中列「实验室三维可视化场景」图片（后台 fields.vsMedia 配置后显示）
    vsMedia() {
      const v = this.$C('productResearch', 'vsMedia', '')
      return v ? this.cmsMediaUrl(v) : ''
    },
    // 视频区媒体地址（取 livePorts[0].url；兼容完整地址与 /media 相对地址）
    mnMedia() {
      const s = this.streams[0]
      return s && s.url ? this.cmsMediaUrl(s.url) : ''
    },
    // 配置的是图片（jpg/png 等）时用 <img> 静态展示，否则按视频播放
    mnIsImage() {
      return this.isImgUrl(this.mnMedia)
    },
    fromChain() {
      return this.$route.query && this.$route.query.from === 'industry-chain'
    },
    yTicks() {
      return [100, 80, 60, 40, 20, 0]
    },
    // 背景与「甘孜市场」完全一致：优先甘孜专属背景(ganzi/pageBg)，其次 CMS 通用市场底图，最后系统默认 bg_shichang.jpg
    rootVars() {
      const bg = this.$C('ganzi', 'pageBg', '')
      if (bg) {
        return { '--page-bg': `url(${mediaUrl(bg)}) center/cover no-repeat #04122e`, '--mol-bg': `url(${mediaUrl(bg)})` }
      }
      return { '--page-bg': `var(--cms-img-market-bg, url(${shichangBg})) center/100% 100% no-repeat #04122e`, '--mol-bg': `url(${shichangBg})` }
    },
  },
  mounted() {
    this.$nextTick(() => this.calc())
    window.addEventListener('resize', this.calc)
    window.addEventListener('keydown', this.onKey)
    this.updateClock()
    this.clockTimer = setInterval(this.updateClock, 15000)
  },
  activated() {
    this.$nextTick(() => this.calc())
    this.updateClock()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calc)
    window.removeEventListener('keydown', this.onKey)
    if (this.clockTimer) clearInterval(this.clockTimer)
    this.clearHover()
    this.stopSpin()
  },
  watch: {
    moleculeOpen(v) {
      if (v) this.renderMolecule()
      else { this.stopSpin(); this.clearHover() }
    },
    moleculeIdx() {
      if (this.moleculeOpen) { this.stopSpin(); this.renderMolecule() }
    },
  },
  methods: {
    goBack() {
      if (this.fromChain) this.$router.replace('/industry-chain')
      else if (window.history.length > 1) this.$router.back()
      else this.$router.replace('/industry-chain')
    },
    // 某分组下两根柱（成都 / 炉霍）
    trialBars(gi) {
      return [
        { k: 'cd', v: this.trial.chengdu[gi] },
        { k: 'lh', v: this.trial.luhuo[gi] },
      ]
    },
    updateClock() {
      const d = new Date()
      const p = n => (n < 10 ? '0' : '') + n
      this.nowText = d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes())
    },
    // ===== 公共资源地址（兼容 dev '/' 与 prod './'；绝对地址直接返回） =====
    assetUrl(u) {
      if (!u) return ''
      if (/^(https?:|data:|blob:)/i.test(u)) return u
      return (process.env.BASE_URL || '/') + String(u).replace(/^\//, '')
    },
    // CMS 媒体地址：/media/... 经 mediaUrl 转 /cms-media/...（dev 代理→3001，prod nginx 反代）
    cmsMediaUrl(u) {
      if (!u) return ''
      if (/^(https?:|data:|blob:)/i.test(u)) return u
      return mediaUrl(u)
    },
    // 图片扩展名判断（决定视频区用 <img> 还是 <video>）
    isImgUrl(u) {
      return /\.(jpg|jpeg|png|gif|webp|bmp|svg)(\?|#|$)/i.test(u || '')
    },
    // ===== 专利灯箱 / 论文 PDF =====
    openPatent(i) { this.patReset(); this.lightbox = i },
    stepPatent(d) {
      const n = this.patents.length
      if (!n) return
      this.patReset()
      this.lightbox = (this.lightbox + d + n) % n
    },
    // ===== 灯箱图片：滚轮缩放 / 按住拖动平移 / 双击复位 =====
    patReset() {
      this.patZoom = 1; this.patX = 0; this.patY = 0; this.patDragging = false
      this._patDrag = null
    },
    patWheel(e) {
      const f = e.deltaY < 0 ? 1.18 : 1 / 1.18
      this.patZoom = Math.min(8, Math.max(1, this.patZoom * f))
      if (this.patZoom === 1) { this.patX = 0; this.patY = 0 }
    },
    patDown(e) {
      this._patDrag = { sx: e.clientX, sy: e.clientY, ox: this.patX, oy: this.patY }
      this.patDragging = true
      window.addEventListener('mousemove', this.patMove)
      window.addEventListener('mouseup', this.patUp)
    },
    patMove(e) {
      const d = this._patDrag
      if (!d) return
      // 视口像素 → 舞台布局像素（弹层整体被 --screen-scale 缩放，需除以实际缩放比）
      const stage = document.querySelector('.pr-lightbox .pr-ov-stage')
      const k = stage ? stage.getBoundingClientRect().width / stage.offsetWidth : 1
      this.patX = d.ox + (e.clientX - d.sx) / k
      this.patY = d.oy + (e.clientY - d.sy) / k
    },
    patUp() {
      this._patDrag = null
      this.patDragging = false
      window.removeEventListener('mousemove', this.patMove)
      window.removeEventListener('mouseup', this.patUp)
    },
    openPaper(i) { this.paperIdx = i },
    closeOverlays() { this.lightbox = null; this.paperIdx = null },
    // ===== 分子下级页 =====
    openMolecule(i) { this.moleculeIdx = i; this.moleculeOpen = true },
    closeMolecule() {
      this.moleculeOpen = false
      this.stopSpin()
      this.clearHover()
      this.disableWheelZoom()
      try { if (this._viewer) this._viewer.clear() } catch (e) { /* ignore */ }
      this._viewer = null
      const el = this.$refs.molCanvas
      if (el) el.innerHTML = ''
      this.viewerReady = false
    },
    onKey(e) {
      if (e.key === 'Escape') {
        if (this.lightbox !== null || this.paperIdx !== null) this.closeOverlays()
        else if (this.moleculeOpen) this.closeMolecule()
      } else if (this.lightbox !== null) {
        if (e.key === 'ArrowLeft') this.stepPatent(-1)
        else if (e.key === 'ArrowRight') this.stepPatent(1)
      }
    },
    // ===== 3Dmol.js 按需加载与渲染 =====
    load3Dmol() {
      if (window.$3Dmol) return Promise.resolve(window.$3Dmol)
      if (!this._molLib) {
        this._molLib = new Promise((resolve, reject) => {
          const s = document.createElement('script')
          s.src = this.assetUrl('vendor/3Dmol-min.js')
          s.onload = () => resolve(window.$3Dmol)
          s.onerror = () => reject(new Error('3Dmol.js 加载失败'))
          document.head.appendChild(s)
        })
      }
      return this._molLib
    },
    async renderMolecule() {
      this.viewerReady = false
      this.hoverInfo = null
      const m = this.activeMolecule
      if (!m || !m.file) return
      try {
        const $3Dmol = await this.load3Dmol()
        const res = await fetch(this.assetUrl(m.file))
        if (!res.ok) throw new Error('结构文件 HTTP ' + res.status)
        const data = await res.text()
        await this.$nextTick()
        const el = this.$refs.molCanvas
        if (!el || !this.moleculeOpen) return
        el.innerHTML = ''
        // 3Dmol 按元素布局尺寸×2 自建 WebGL 缓冲；缩放舞台下布局像素很大（约6880×1982），
        // 直接建缓冲会超预算。用内层元素把布局尺寸压到预算内，再 transform 等比拉伸铺满，
        // 显示尺寸不变、缓冲 ≤ 4096×2160，防止 GPU 上下文丢失。
        let inner = document.createElement('div')
        inner.className = 'pr-mol-inner'
        // 动态创建的元素没有 scoped 属性，<style scoped> 不会命中，定位全部走内联样式
        inner.style.position = 'absolute'
        inner.style.left = '50%'
        inner.style.top = '50%'
        el.appendChild(inner)
        const cw = Math.max(320, el.clientWidth)
        const ch = Math.max(240, el.clientHeight)
        const MAXL = 2560 * 740 // 内层布局面积上限（缓冲=布局×2 → 5120×1480 ≈ 预算内）
        const f = Math.min(1, Math.sqrt(MAXL / (cw * ch)))
        inner.style.width = Math.round(cw * f) + 'px'
        inner.style.height = Math.round(ch * f) + 'px'
        inner.style.transform = 'translate(-50%, -50%) scale(' + (1 / f) + ')'
        const viewer = $3Dmol.createViewer(inner, {
          backgroundColor: 'rgba(2,10,28,0)',
          hoverDuration: 60,
          // 悬停拾取：本版 3Dmol 走 createViewer config 的 callback（无 setHoverCallback API）
          callback: (atom) => {
            this.hoverInfo = atom ? this.describeAtom(atom) : null
            try { viewer.render() } catch (e) { /* ignore */ }
          },
        })
        this._viewer = viewer
        viewer.addModel(data, m.format || 'pdb')
        this.applyMoleculeStyle(viewer, m.style)
        viewer.zoomTo()
        viewer.render()
        this.viewerReady = true
        // 默认进入自动自转状态，可通过「停止自转」按钮停止（6 个分子统一此行为）
        this.spinOn = true
        try { viewer.spin('y', 1.2) } catch (e) { /* ignore */ }
        this.enableHover(viewer, el)
      } catch (err) {
        this.viewerReady = false
        console.error('[molecule] render failed:', (err && (err.stack || err.message)) || err)
      }
    },
    applyMoleculeStyle(viewer, styleKey) {
      if (styleKey === 'ligand' || styleKey === 'peptide') {
        // 小分子 / 多肽：球棍模型
        viewer.setStyle({}, {
          stick: { radius: 0.28, color: 'spectrum', hoverable: true },
          sphere: { scale: 0.28, color: 'spectrum', hoverable: true },
        })
      } else {
        // 蛋白质：卡通骨架 + 侧链细棍（可悬停拾取原子）
        viewer.setStyle({}, {
          cartoon: { color: 'spectrum', arrows: true },
          stick: { radius: 0.18, color: 'spectrum', hoverable: true },
        })
      }
    },
    enableHover(viewer, el) {
      const stage = el.closest('.pr-mol-stage')
      this._stageMove = (ev) => {
        if (!stage) return
        const r = stage.getBoundingClientRect()
        // 视口坐标 → 舞台布局坐标（舞台被 --screen-scale 缩放，需除以实际缩放比）
        const sc = r.width / (stage.offsetWidth || 1) || 1
        this.tipPos = { x: (ev.clientX - r.left) / sc + 20, y: (ev.clientY - r.top) / sc + 20 }
      }
      if (stage) stage.addEventListener('mousemove', this._stageMove)
      // 悬停回调已在 createViewer config.callback 注册；此处仅做兼容设置
      try { if (typeof viewer.setHoverDuration === 'function') viewer.setHoverDuration(60) } catch (e) { /* ignore */ }
      // 接管滚轮缩放：捕获阶段拦截 3Dmol 自带的 canvas wheel 监听，强制
      // 「鼠标向前推（滚动上滚）→ 放大，向后拉（滚动下滚）→ 缩小」
      this.enableWheelZoom(viewer, el)
    },
    enableWheelZoom(viewer, el) {
      this.disableWheelZoom()
      const stage = el.closest('.pr-mol-stage') || el
      // capture 阶段先于 3Dmol 绑定在 canvas 上的冒泡监听执行，stopImmediatePropagation 可阻断它
      this._wheelHandler = (ev) => {
        ev.preventDefault()
        ev.stopImmediatePropagation()
        // 标准 WheelEvent：deltaY < 0 为上滚（向前推）→ 放大；deltaY > 0 为下滚（向后拉）→ 缩小
        const factor = ev.deltaY < 0 ? 1.12 : (ev.deltaY > 0 ? 1 / 1.12 : 1)
        try { viewer.zoom(factor); viewer.render() } catch (e) { /* ignore */ }
      }
      stage.addEventListener('wheel', this._wheelHandler, { capture: true, passive: false })
    },
    disableWheelZoom() {
      if (this._wheelHandler && this.$refs.molCanvas) {
        const stage = this.$refs.molCanvas.closest('.pr-mol-stage')
        if (stage) stage.removeEventListener('wheel', this._wheelHandler, { capture: true })
      }
      this._wheelHandler = null
    },
    describeAtom(a) {
      const rows = [{ k: '分子', v: this.activeMolecule.molecule }]
      const sym = String(a.elem || a.symbol || '').trim()
      const NAME = { C: '碳', H: '氢', O: '氧', N: '氮', S: '硫', P: '磷', FE: '铁', CA: '钙', ZN: '锌', SE: '硒' }
      if (sym && sym !== '?') {
        rows.push({ k: '元素', v: sym + (NAME[sym.toUpperCase()] ? '（' + NAME[sym.toUpperCase()] + '）' : '') })
      }
      if (a.resn) rows.push({ k: '残基', v: a.resn + (a.resi !== undefined ? ' ' + a.resi : '') })
      if (a.chain) rows.push({ k: '链', v: String(a.chain).toUpperCase() })
      if (sym) rows.push({ k: '原子序号', v: String(a.serial !== undefined ? a.serial : (a.index !== undefined ? a.index : '-')) })
      return rows
    },
    clearHover() {
      this.hoverInfo = null
      const stage = this.$refs.molCanvas && this.$refs.molCanvas.closest('.pr-mol-stage')
      if (stage && this._stageMove) {
        stage.removeEventListener('mousemove', this._stageMove)
        this._stageMove = null
      }
    },
    stopSpin() {
      try { if (this._viewer) this._viewer.spin(false) } catch (e) { /* ignore */ }
      this.spinOn = false
    },
    toggleSpin() {
      const v = this._viewer
      if (!v) return
      this.spinOn = !this.spinOn
      try {
        if (this.spinOn) v.spin('y', 1.2)
        else { v.spin(false); v.render() }
      } catch (e) { /* ignore */ }
    },
    resetView() {
      try {
        this._viewer.zoomTo()
        this._viewer.render()
      } catch (e) { /* ignore */ }
    },
    resizeViewer() {
      const v = this._viewer
      if (!v || !this.moleculeOpen) return
      try { v.resize() } catch (e) { /* ignore */ }
    },
    // 悬浮球状体样式（径向渐变光球 + 位置/尺寸）
    orbStyle(o) {
      return {
        left: o.x + '%',
        top: o.y + '%',
        width: o.s + 'px',
        height: o.s + 'px',
        background: 'radial-gradient(circle at 35% 30%, ' + o.c + ' 0%, ' + o.c + '55 40%, rgba(0,0,0,0) 72%)',
      }
    },
    // 氨基酸条形相对宽度（以最大值为基准）
    aaBarWidth(a) {
      const w = (a.pct / this.aaMax) * 100
      return Math.min(100, w).toFixed(1) + '%'
    },
    // 7680×2160 舞台等比"包含"缩放，整页一次看完不滚动
    calc() {
      const vp = this.$refs.viewport
      const stage = this.$refs.stage
      const box = this.$refs.box
      if (!vp || !stage || !box) return
      const s = Math.min(vp.clientWidth / 7680, vp.clientHeight / 2160)
      this.scale = s
      stage.style.transform = `scale(${s})`
      box.style.width = 7680 * s + 'px'
      box.style.height = 2160 * s + 'px'
      if (this._viewer && this.moleculeOpen) { try { this.resizeViewer() } catch (e) { /* ignore */ } }
    },
  },
  // 浮层传送门：渲染后搬到 document.body。
  // 应用外壳 main-layout 自带 transform:scale()，会把内部所有 position:fixed
  // 的包含块劫持为缩放舞台（浮层只能盖住半屏、按钮被缩到 1/4）。
  // 挂到 body 后 fixed 才相对视口定位，浮层恢复真实像素全屏。
  directives: {
    portal: {
      inserted(el) { document.body.appendChild(el) },
    },
  },
}
</script>

<style lang="less" scoped>
.pr-page {
  position: fixed;
  inset: 0;
  z-index: 1000; /* 覆盖大屏导航条，页面自带返回键 */
  background: var(--page-bg);
  color: #eaf3ff;
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
}
.pr-viewport {
  position: absolute;
  inset: 0;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pr-scale-box { position: relative; }
.pr-stage {
  width: 7680px;
  height: 2160px;
  transform-origin: top left;
  padding: 44px 100px 56px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

/* ---------- 页头 ---------- */
.pr-head {
  flex: none;
  height: 140px;
  display: flex;
  align-items: center;
  gap: 40px;
}
.pr-back {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 20px;
  padding: 18px 48px;
  font-size: 44px;
  color: #eaf3ff;
  background: rgba(0, 229, 255, 0.12);
  border: 2px solid rgba(0, 229, 255, 0.5);
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  &:hover { background: rgba(0, 229, 255, 0.26); box-shadow: 0 0 44px rgba(0, 229, 255, 0.45); }
}
.pr-back-arrow { color: #31FFFF; font-size: 48px; }
.pr-banner {
  flex: 1;
  height: 108px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(90deg, rgba(30, 111, 210, 0.06) 0%, rgba(30, 111, 210, 0.85) 14%, rgba(17, 80, 158, 0.9) 86%, rgba(17, 80, 158, 0.06) 100%);
  clip-path: polygon(30px 0, calc(100% - 30px) 0, 100% 50%, calc(100% - 30px) 100%, 30px 100%, 0 50%);
}
.pr-title {
  margin: 0;
  font-size: 62px;
  font-weight: 700;
  letter-spacing: 10px;
  color: #fff;
  text-shadow: 0 0 36px rgba(0, 229, 255, 0.55);
  white-space: nowrap;
}
.pr-clock {
  flex: none;
  min-width: 400px;
  text-align: right;
  font-size: 44px;
  color: #cfe6ff;
  letter-spacing: 3px;
}

/* ---------- 布局（按用户参考图排布，尺寸按 7680×2160 舞台精确计算） ----------
   网格区 7480×1896，间距 24；面板头 96，body 内边距 18/30/22（媒体区=body 内容盒）
   左列 1476：项目总览 892 + 设备运行 980（两区不变）
   中列通高 3189：可视化场景媒体区 3129×1760 = 16:9
   右列 2770：上排高 798（试验 1727 + 论文 1013）；下排高 1074（视频 1727 媒体区 1667×938 = 16:9 + 专利 1013） */
.pr-grid {
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  gap: 24px;
}
.pr-col {
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.pr-col-l { flex: none; width: 1476px; }
.pr-col-l .pj-panel { flex: none; height: 892px; }
.pr-col-l .dv-panel { flex: 1; min-height: 0; }
.vs-panel { flex: none; width: 3186px; }
.pr-col-r { flex: 1; min-width: 0; }
.pr-row {
  min-height: 0;
  min-width: 0;
  display: flex;
  gap: 24px;
}
.pr-row-top { flex: none; height: 798px; }
.pr-row-btm { flex: none; height: 1074px; }
.pr-row-top .trial-panel { flex: 1; min-width: 0; }
.pt-panel { flex: none; width: 1019px; }
.pr-row-btm .mn-panel { flex: 1; min-width: 0; }
.pp-panel { flex: none; width: 1019px; }
.pr-panel {
  background: rgba(23, 96, 190, 0.16);
  border: 2px solid rgba(96, 160, 245, 0.5);
  border-radius: 16px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}
.pr-panel-head {
  flex: none;
  height: 96px;
  display: flex;
  align-items: center;
  gap: 30px;
  padding: 0 30px;
  background: linear-gradient(90deg, #1E6FD2 0%, #11509E 100%);
}
.pr-panel-title {
  color: #00E5FF;
  font-size: 46px;
  font-weight: 700;
  letter-spacing: 4px;
  white-space: nowrap;
}
.pr-panel-body {
  flex: 1;
  min-height: 0;
  padding: 18px 30px 22px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

/* ---------- 名单通用（项目 / 设备 / 论文） ---------- */
.pr-total-line {
  flex: none;
  margin: 4px 0 8px;
  font-size: 42px;
  color: #cfe6ff;
  b { font-size: 72px; color: #FFD942; margin: 0 10px; }
}
.pr-row-list {
  flex: 1;
  min-height: 0;
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  li {
    flex: 1;
    min-height: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    border-bottom: 2px dashed rgba(96, 160, 245, 0.25);
    &:last-child { border-bottom: none; }
  }
}
.pj-panel .pr-row-list li {
  cursor: pointer;
  transition: background 0.2s;
  &:hover { background: rgba(0, 229, 255, 0.08); }
}
.pr-item-name {
  font-size: 40px;
  color: #eaf3ff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.pr-item-status { font-style: normal; font-size: 38px; font-weight: 600; white-space: nowrap; }
.pj-done { color: #31E58B; }
.pj-declared { color: #31FFFF; }
.pj-pending { color: #9fc0e8; }
.pj-doing { color: #FFC857; }
.dv-running { color: #31E58B; }
.dv-standby { color: #4F9DFF; }

/* ---------- 产品试验柱状图 ---------- */
.pr-legend {
  margin-left: auto;
  display: flex;
  gap: 44px;
  font-size: 32px;
  color: #cfe6ff;
  white-space: nowrap;
  .dot { display: inline-block; width: 40px; height: 14px; border-radius: 7px; margin-right: 12px; vertical-align: middle; }
  .dot.cd { background: #31FFFF; }
  .dot.lh { background: #FF9845; }
}
.pr-chart-title {
  flex: none;
  text-align: center;
  height: 54px;
  line-height: 54px;
  font-size: 38px;
  color: #cfe6ff;
}
.pr-chart-body {
  flex: 1;
  min-height: 0;
  display: flex;
}
.pr-yaxis {
  flex: none;
  width: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 16px;
  padding-bottom: 54px; /* 对齐柱区底部（x 轴标签高） */
  font-size: 30px;
  color: #9fc0e8;
}
.pr-bars { flex: 1; min-width: 0; display: flex; }
.pr-group { flex: 1; min-width: 0; display: flex; flex-direction: column; }
.pr-bars-row {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 18px;
  border-bottom: 2px solid rgba(96, 160, 245, 0.35);
  /* 每 20% 一条横向网格线 */
  background: repeating-linear-gradient(to top, rgba(96, 160, 245, 0.16) 0, rgba(96, 160, 245, 0.16) 2px, transparent 2px, transparent 20%);
}
.pr-bar-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}
.pr-bar-val { flex: none; font-style: normal; font-size: 28px; color: #eaf3ff; margin-bottom: 8px; }
.pr-bar {
  flex: none;
  width: 88px;
  border-radius: 8px 8px 0 0;
}
.pr-bar.cd { background: linear-gradient(180deg, #59E9FF, #1178C8); box-shadow: 0 0 24px rgba(49, 255, 255, 0.25); }
.pr-bar.lh { background: linear-gradient(180deg, #FFB45C, #E07818); box-shadow: 0 0 24px rgba(255, 152, 69, 0.25); }
.pr-x-label {
  flex: none;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 34px;
  color: #cfe6ff;
  white-space: nowrap;
}

/* ---------- 研发专利（证书缩略图分页，点击全屏放大） ---------- */
.pr-pt-grid {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-auto-rows: 1fr;
  gap: 16px;
}
.pr-pt {
  min-height: 0;
  border: 2px solid rgba(255, 215, 90, 0.4);
  border-radius: 12px;
  background: rgba(255, 215, 90, 0.05);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 12px;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.2s, box-shadow 0.2s;
  &:hover { border-color: rgba(255, 215, 90, 0.9); box-shadow: 0 0 30px rgba(255, 215, 90, 0.25); }
}
.pr-pt-pic {
  flex: 1;
  min-height: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.pr-pt-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.45);
  background: #fff;
}
.pr-pt-name {
  flex: none;
  max-width: 100%;
  font-size: 24px;
  line-height: 1.25;
  text-align: center;
  color: #eaf3ff;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.pr-pt-no {
  flex: none;
  font-size: 19px;
  color: rgba(255, 215, 90, 0.85);
  white-space: nowrap;
}
.pr-pt-pager {
  flex: none;
  height: 58px;
  margin-top: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 26px;
}
.pr-pt-pg-btn {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  border: 2px solid rgba(0, 229, 255, 0.55);
  background: rgba(0, 229, 255, 0.1);
  color: #31FFFF;
  font-size: 34px;
  line-height: 1;
  cursor: pointer;
  &:hover:not(:disabled) { background: rgba(0, 229, 255, 0.28); }
  &:disabled { opacity: 0.3; cursor: default; }
}
.pr-pt-pg-num { font-size: 30px; color: #cfe6ff; letter-spacing: 2px; }

/* ---------- 论文区（点击打开 PDF 全文） ---------- */
.pr-pp-list li { justify-content: flex-start; cursor: pointer; transition: background 0.2s; &:hover { background: rgba(0, 229, 255, 0.07); } }
.pr-pp-idx {
  flex: none;
  width: 52px;
  height: 52px;
  margin-right: 20px;
  border-radius: 10px;
  background: rgba(0, 229, 255, 0.14);
  border: 2px solid rgba(0, 229, 255, 0.45);
  color: #31FFFF;
  font-size: 30px;
  font-weight: 700;
  font-style: normal;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pr-pp-name {
  flex: 1;
  min-width: 0;
  font-size: 36px;
  color: #eaf3ff;
  line-height: 1.35;
  white-space: normal;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.pr-pp-go {
  flex: none;
  margin-left: 18px;
  padding: 8px 20px;
  border-radius: 999px;
  background: rgba(255, 107, 107, 0.14);
  border: 2px solid rgba(255, 107, 107, 0.55);
  color: #FF8B8B;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: 2px;
}

/* ---------- 研发项目 3D 徽标 ---------- */
.pr-item-3d {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 16px;
  padding: 2px 12px;
  border-radius: 8px;
  background: rgba(0, 229, 255, 0.14);
  border: 2px solid rgba(0, 229, 255, 0.5);
  color: #31FFFF;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 1px;
  vertical-align: 4px;
}

/* ---------- 待接入占位（可视化场景 / 实时监控） ---------- */
.pr-ph {
  flex: 1;
  min-height: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  overflow: hidden;
  background: rgba(4, 18, 46, 0.4);
}
.pr-ph-grid {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(79, 163, 255, 0.12) 2px, transparent 2px),
    linear-gradient(90deg, rgba(79, 163, 255, 0.12) 2px, transparent 2px);
  background-size: 160px 160px;
}
.pr-ph-text {
  position: relative;
  margin: 0;
  font-size: 58px;
  letter-spacing: 8px;
  color: rgba(234, 243, 255, 0.88);
  text-align: center;
}

/* ---------- 视频区（单一监控面板，媒体显示区 16:9，body 内容盒即媒体区） ---------- */
.pr-video { flex: 1; min-height: 0; width: 100%; object-fit: cover; background: #04122e; display: block; border-radius: 12px; }
/* 静态媒体图（三维场景 / 视频区实景图）：与 pr-video 同一布局表现，铺满面板媒体区 */
.pr-media { flex: 1; min-height: 0; width: 100%; height: 100%; object-fit: cover; background: #04122e; display: block; border-radius: 12px; }

/* =========================================================================
   全屏浮层（v-portal 挂 document.body）
   根节点 fixed 铺满真实视口（仅兜底深色底），内容包在 .pr-ov-stage ——
   7680×2160 设计舞台，复用应用外壳的 --screen-scale 等比缩放并居中，
   与主界面完全同分辨率、同比例、同可视区域，绝不超出主界面显示范围。
   ========================================================================= */
.pr-lightbox, .pr-pdfview, .pr-molecule {
  position: fixed;
  inset: 0;
  z-index: 4000;
  background: #020818;
  overflow: hidden;
}
.pr-ov-stage {
  position: absolute;
  left: 0;
  top: 0;
  /* 复用应用外壳（index.vue）挂在 body 上的设计尺寸与缩放变量，保证与主界面完全同源 */
  width: var(--screen-width, 7680px);
  height: var(--screen-height, 2160px);
  transform: var(--screen-scale, scale(1));
  transform-origin: left top;
  display: flex;
  flex-direction: column;
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
  color: #eaf3ff;
}
/* 分子页舞台专属背景（渐变 + 底图随舞台同比例，不铺满视口） */
.pr-ov-stage.pr-ov-molbg {
  background:
    linear-gradient(160deg, rgba(4, 18, 46, 0.94) 0%, rgba(10, 34, 72, 0.9) 55%, rgba(6, 22, 52, 0.96) 100%),
    var(--mol-bg, none) center/cover no-repeat #030b1e;
}
.pr-close-btn {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: 56px;
  padding: 0 28px;
  border-radius: 999px;
  border: 2px solid rgba(0, 229, 255, 0.75);
  background: rgba(0, 229, 255, 0.14);
  color: #31FFFF;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 2px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  &:hover { background: rgba(0, 229, 255, 0.32); box-shadow: 0 0 26px rgba(0, 229, 255, 0.5); }
  .pr-close-x { font-size: 30px; line-height: 1; }
}

/* ---------- 专利证书灯箱 ---------- */
.pr-light-head { flex: none; display: flex; align-items: flex-start; justify-content: space-between; gap: 30px; padding: 30px 40px 14px; }
.pr-light-name { margin: 0; font-size: 60px; font-weight: 700; color: #eaf6ff; line-height: 1.25; }
.pr-light-no { margin: 12px 0 0; font-size: 40px; color: #FFD942; }
.pr-light-hint { margin: 12px 0 0; font-size: 28px; color: rgba(207, 230, 255, 0.75); }
.pr-light-body {
  flex: 1;
  min-height: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 120px 34px;
  box-sizing: border-box;
  overflow: hidden;
}
.pr-light-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 24px 90px rgba(0, 0, 0, 0.65);
  cursor: grab;
  transition: transform 0.08s linear;
  will-change: transform;
  user-select: none;
  -webkit-user-drag: none;
  &.grabbing { cursor: grabbing; transition: none; }
}
.pr-light-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 72px;
  height: 72px;
  border-radius: 50%;
  border: 2px solid rgba(0, 229, 255, 0.6);
  background: rgba(0, 229, 255, 0.12);
  color: #31FFFF;
  font-size: 44px;
  line-height: 1;
  cursor: pointer;
  transition: all 0.2s;
  &:hover { background: rgba(0, 229, 255, 0.3); }
  &.prev { left: 28px; }
  &.next { right: 28px; }
}

/* ---------- 论文 PDF 弹层 ---------- */
.pr-pdf-panel {
  flex: 1;
  min-height: 0;
  margin: 20px 40px 30px;
  display: flex;
  flex-direction: column;
  border-radius: 14px;
  background: #0b1c3c;
  border: 2px solid rgba(96, 160, 245, 0.45);
  overflow: hidden;
}
.pr-pdf-head { flex: none; display: flex; align-items: center; justify-content: space-between; gap: 30px; padding: 34px 40px; background: rgba(30, 111, 210, 0.25); }
.pr-pdf-title { margin: 0; flex: 1; min-width: 0; font-size: 42px; font-weight: 700; color: #eaf6ff; line-height: 1.4; }
.pr-pdf-actions { flex: none; display: flex; align-items: center; gap: 18px; }
.pr-pdf-head .pr-close-btn { height: 68px; font-size: 32px; padding: 0 34px; }
.pr-pdf-new {
  display: inline-flex;
  align-items: center;
  height: 68px;
  padding: 0 34px;
  border-radius: 999px;
  border: 2px solid rgba(49, 230, 139, 0.6);
  background: rgba(49, 230, 139, 0.12);
  color: #31E58B;
  font-size: 32px;
  font-weight: 700;
  text-decoration: none;
  &:hover { background: rgba(49, 230, 139, 0.28); }
}
.pr-pdf-frame { flex: 1; min-height: 0; width: 100%; border: none; background: #fff; }

/* ---------- 三维分子结构下级页（字号整体加倍版） ---------- */
.pr-molecule { background: #030b1e; }
.pr-molecule .pr-close-btn { height: 76px; font-size: 40px; padding: 0 40px; }
.pr-mol-head { flex: none; height: 124px; display: flex; align-items: center; gap: 30px; padding: 0 36px; border-bottom: 2px solid rgba(96, 160, 245, 0.3); }
.pr-mol-back {
  flex: none;
  padding: 18px 44px;
  border-radius: 999px;
  border: 2px solid rgba(0, 229, 255, 0.55);
  background: rgba(0, 229, 255, 0.12);
  color: #31FFFF;
  font-size: 48px;
  cursor: pointer;
  &:hover { background: rgba(0, 229, 255, 0.3); }
}
.pr-mol-title { margin: 0; flex: 1; text-align: center; font-size: 68px; font-weight: 700; letter-spacing: 6px; color: #fff; }
.pr-mol-title-en { display: block; font-size: 30px; letter-spacing: 5px; color: rgba(49, 255, 255, 0.6); font-weight: 400; }
.pr-mol-body { flex: 1; min-height: 0; display: flex; flex-direction: column; gap: 20px; padding: 20px 28px 24px; box-sizing: border-box; }
/* 分子主区（导航 + 3D 视图 + 信息）与底部分析区纵向排布 */
.pr-mol-main { flex: 1; min-height: 0; display: flex; gap: 20px; }
/* 底部三块分析面板（置信度曲线 / 氨基酸组成 / 磷酸化板） */
.pr-mol-analysis { flex: none; height: 648px; display: flex; gap: 20px; }
.pr-an-panel { flex: 1; min-width: 0; display: flex; flex-direction: column; border-radius: 14px; border: 2px solid rgba(96,160,245,0.4); background: rgba(23,96,190,0.14); overflow: hidden; }
.pr-an-head { flex: none; height: 88px; display: flex; align-items: center; gap: 18px; padding: 0 28px; background: linear-gradient(90deg, rgba(30,111,210,0.5), rgba(17,80,158,0.30)); }
.pr-an-no { flex: none; width: 54px; height: 54px; border-radius: 12px; background: rgba(0,229,255,0.16); border: 2px solid rgba(0,229,255,0.5); color: #31FFFF; font-size: 30px; font-weight: 700; display: flex; align-items: center; justify-content: center; }
.pr-an-title { font-size: 42px; font-weight: 700; color: #00E5FF; letter-spacing: 3px; }
.pr-an-body { flex: 1; min-height: 0; padding: 16px 26px 18px; display: flex; flex-direction: column; box-sizing: border-box; }
.pr-an-empty { flex: 1; display: flex; align-items: center; justify-content: center; font-size: 36px; color: rgba(207,230,255,0.6); text-align: center; padding: 0 30px; }
.pr-an-foot { flex: none; display: flex; justify-content: space-between; gap: 20px; font-size: 30px; color: #cfe6ff; margin-top: 10px; }
.pr-an-foot-r2 { justify-content: flex-end; }
/* 置信度曲线 */
.pr-an-svg { flex: 1; min-height: 0; width: 100%; display: block; }
/* 氨基酸组成 */
.pr-aa-row { flex: 1; min-height: 0; display: flex; align-items: center; gap: 14px; }
.pr-aa-code { flex: none; width: 76px; font-size: 30px; color: #31FFFF; font-weight: 700; }
.pr-aa-name { flex: none; width: 132px; font-size: 28px; color: #cfe6ff; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pr-aa-track { flex: 1; min-width: 0; height: 26px; background: rgba(255,255,255,0.06); border-radius: 13px; overflow: hidden; }
.pr-aa-bar { display: block; height: 100%; border-radius: 13px; background: linear-gradient(90deg, #FFB45C, #E07818); box-shadow: 0 0 18px rgba(255,152,69,0.3); }
.pr-aa-pct { flex: none; width: 96px; text-align: right; font-size: 30px; color: #FFD942; font-weight: 700; }
/* 磷酸化板 */
.pr-phos-body { flex-direction: column; gap: 14px; }
.pr-phos-grid { flex: 1; min-height: 0; overflow: auto; display: grid; gap: 6px; align-content: start; grid-template-columns: repeat(var(--cols, 18), 1fr); justify-content: center; padding-right: 4px; }
.pr-phos-dot { width: 100%; max-width: 20px; aspect-ratio: 1 / 1; margin: 0 auto; border-radius: 50%; background: rgba(79,163,255,0.22); }
.pr-phos-dot.b-hi { background: rgba(49,229,139,0.55); }
.pr-phos-dot.b-mid { background: rgba(255,201,66,0.5); }
.pr-phos-dot.b-lo { background: rgba(255,107,107,0.5); }
.pr-phos-dot.phos { background: #FF8A3C; box-shadow: 0 0 14px rgba(255,138,60,0.9); border: 2px solid #FFD942; }
.pr-phos-legend { flex: none; list-style: none; margin: 0; padding: 0; display: flex; flex-direction: column; gap: 10px; }
.pr-phos-legend li { font-size: 28px; color: #cfe6ff; display: flex; align-items: center; gap: 12px; }
.pr-phos-legend b { color: #FFD942; margin-left: 2px; font-size: 30px; }
.pr-phos-legend .lg { width: 22px; height: 22px; border-radius: 50%; flex: none; }
.lg.phos { background: #FF8A3C; border: 2px solid #FFD942; }
.lg.hi { background: rgba(49,229,139,0.7); }
.lg.lo { background: rgba(255,107,107,0.7); }
.lg.est { background: rgba(0,229,255,0.5); }
/* 分子信息栏：基因/登录号 + 统计 */
.pr-mol-meta { flex: none; display: flex; flex-wrap: wrap; align-items: center; gap: 4px 10px; margin: 4px 0 2px; font-size: 30px; }
.pr-mol-meta-k { color: rgba(207,230,255,0.6); margin-left: 10px; }
.pr-mol-meta-k:first-child { margin-left: 0; }
.pr-mol-meta-v { color: #31FFFF; font-weight: 600; }
.pr-mol-stats { flex: none; display: flex; gap: 16px; margin: 4px 0 2px; }
.pr-mol-stat { flex: 1; background: rgba(0,229,255,0.08); border: 2px solid rgba(0,229,255,0.35); border-radius: 12px; padding: 12px 16px; }
.pr-mol-stat b { display: block; font-size: 44px; color: #FFD942; line-height: 1.1; }
.pr-mol-stat i { font-style: normal; font-size: 26px; color: #cfe6ff; }
/* 悬浮球状体 */
.pr-mol-orbs { position: absolute; inset: 0; overflow: hidden; pointer-events: none; z-index: 2; }
.pr-orb { position: absolute; border-radius: 50%; transform: translate(-50%, -50%); filter: blur(1px); opacity: 0.75; box-shadow: 0 0 40px rgba(255,255,255,0.10); animation: pr-orb-float 9s ease-in-out infinite; }
@keyframes pr-orb-float { 0%, 100% { transform: translate(-50%, -50%) translateY(0); } 50% { transform: translate(-50%, -50%) translateY(-26px); } }
.pr-mol-nav {
  flex: none;
  width: 560px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.pr-mol-nav-t { margin: 0 0 4px; font-size: 42px; color: rgba(207, 230, 255, 0.7); letter-spacing: 3px; }
.pr-mol-nav-item {
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 30px;
  border-radius: 12px;
  border: 2px solid rgba(96, 160, 245, 0.35);
  background: rgba(23, 96, 190, 0.14);
  color: #eaf3ff;
  font-size: 46px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: left;
  i { font-style: normal; color: rgba(49, 255, 255, 0.6); font-size: 40px; }
  &:hover { border-color: rgba(0, 229, 255, 0.6); }
  &.on { border-color: rgba(0, 229, 255, 0.9); background: rgba(0, 229, 255, 0.16); box-shadow: 0 0 24px rgba(0, 229, 255, 0.25); span { color: #31FFFF; } }
}
.pr-mol-view { flex: 1; min-width: 0; margin: 0; display: flex; flex-direction: column; }
.pr-mol-stage {
  flex: 1;
  min-height: 0;
  position: relative;
  border-radius: 14px;
  border: 2px solid rgba(96, 160, 245, 0.4);
  background: rgba(2, 10, 28, 0.75);
  overflow: hidden;
}
.pr-mol-canvas { position: absolute; inset: 0; z-index: 1; }
/* 内层实测元素：布局尺寸由 JS 按预算控制，transform 等比拉伸铺满（含居中位移） */
.pr-mol-inner { position: absolute; left: 50%; top: 50%; transform: translate(-50%, -50%); }
.pr-mol-inner canvas { width: 100% !important; height: 100% !important; display: block; }
.pr-mol-loading {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  pointer-events: none;
}
.pr-mol-poster { max-width: 52%; max-height: 62%; object-fit: contain; border-radius: 12px; opacity: 0.9; }
.pr-mol-loading-t { font-size: 52px; color: rgba(207, 230, 255, 0.85); letter-spacing: 4px; animation: pr-pulse 1.4s ease-in-out infinite; }
@keyframes pr-pulse { 0%, 100% { opacity: 0.55; } 50% { opacity: 1; } }
.pr-mol-tools { position: absolute; top: 18px; right:18px; z-index:3; display: flex; gap:14px; }
.pr-mol-tools button {
  padding: 16px 34px;
  border-radius: 999px;
  border: 2px solid rgba(0, 229, 255, 0.55);
  background: rgba(2, 10, 28, 0.7);
  color: #cfe6ff;
  font-size: 40px;
  cursor: pointer;
  &:hover { border-color: rgba(0, 229, 255, 0.9); color: #31FFFF; }
  &.on { background: rgba(0, 229, 255, 0.22); color: #31FFFF; border-color: rgba(0, 229, 255, 0.9); }
}
.pr-mol-hint { position: absolute; left: 20px; bottom: 14px; z-index: 3; margin: 0; font-size: 34px; color: rgba(207, 230, 255, 0.6); }
.pr-mol-tip {
  position: absolute;
  z-index: 5;
  min-width: 320px;
  padding: 20px 26px;
  border-radius: 10px;
  background: rgba(4, 18, 46, 0.94);
  border: 2px solid rgba(0, 229, 255, 0.55);
  box-shadow: 0 10px 34px rgba(0, 0, 0, 0.5);
  pointer-events: none;
}
.pr-mol-tip-name { margin: 0 0 8px; font-size: 40px; font-weight: 700; color: #31FFFF; }
.pr-mol-tip-row { margin: 6px 0 0; font-size: 32px; color: #cfe6ff; em { font-style: normal; color: rgba(207, 230, 255, 0.65); margin-right: 12px; } }
.pr-mol-cap { flex: none; margin: 12px 4px 0; font-size: 42px; color: #cfe6ff; em { font-style: normal; margin-left: 22px; font-size: 36px; color: rgba(207, 230, 255, 0.6); } }
.pr-mol-info {
  flex: none;
  width: 700px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 30px 32px;
  box-sizing: border-box;
  border-radius: 14px;
  border: 2px solid rgba(96, 160, 245, 0.4);
  background: rgba(23, 96, 190, 0.14);
}
.pr-mol-name { margin: 0; font-size: 68px; font-weight: 700; color: #31FFFF; }
.pr-mol-project { margin: 0; font-size: 40px; color: #FFD942; }
.pr-mol-intro {
  flex: 1;
  min-height: 0;
  overflow: auto;
  font-size: 38px;
  line-height: 1.7;
  color: rgba(234, 243, 255, 0.92);
  text-align: justify;
}
.pr-fade-enter-active, .pr-fade-leave-active { transition: opacity 0.15s; }
.pr-fade-enter, .pr-fade-leave-to { opacity: 0; }
</style>
